<template>
  <div class="interaction-notification-container">
    <!-- 头部 -->
    <div class="in-header">
      <div class="in-header-left" @click="$emit('close')">
        <van-icon name="arrow-left" size="20" color="#1A1A1A" />
      </div>
      <div class="in-header-title">{{ $t('interaction_notification_title') }}</div>
      <div class="in-header-right" @click="markAllRead" v-if="notifications.length > 0">
        <span style="font-size: 13px; color: #E8543A;">{{ $t('mark_all_read') || 'Mark all read' }}</span>
      </div>
      <div class="in-header-right" v-else></div>
    </div>

    <!-- 列表 -->
    <div class="in-list-wrapper">
      <van-pull-refresh v-model="refreshing" :loading-text="$t('loading')" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :loading-text="$t('loading')" @load="onLoad">
          <!-- 空状态 -->
          <van-empty v-if="notifications.length === 0 && !loading" :description="$t('interaction_notification_empty')" />

          <div v-for="notification in notifications" :key="notification.interactionNotificationId"
            class="in-item" @click="onNotificationClick(notification)">
            <div class="in-avatar">
              <img v-if="notification.fromUserAvatar" :src="$common.getFullImageUrl(notification.fromUserAvatar, $config, 's')"
                style="width: 44px; height: 44px; border-radius: 50%;" />
              <div v-else class="in-avatar-placeholder">{{ (notification.fromUserName || $t('anonymous'))[0] }}</div>
            </div>
            <div class="in-content">
              <div class="in-name-line">
                <span class="in-username">{{ notification.fromUserName || $t('anonymous') }}</span>
                <span class="in-time">{{ $common.formatSmartTime(notification.createdAt, $i18n.locale) }}</span>
              </div>
              <div class="in-desc" :class="{ 'in-unread': notification.isRead == 0 }">
                {{ getNotificationDesc(notification) }}
              </div>
            </div>
            <div class="in-right">
              <div v-if="notification.isRead == 0" class="in-unread-dot"></div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import { List, PullRefresh, Empty, Icon, Toast } from 'vant'

Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Empty)
Vue.use(Icon)
Vue.use(Toast)

export default {
  name: 'InteractionNotification',
  data() {
    return {
      notifications: [],
      loading: false,
      finished: false,
      refreshing: false,
      curPage: 1,
      pageSize: 20
    }
  },
  mounted() {
    this.onRefresh()
  },
  methods: {
    onRefresh() {
      this.notifications = []
      this.curPage = 1
      this.finished = false
      this.refreshing = true
      this.onLoad()
    },
    onLoad() {
      let vm = this
      if (vm.finished || vm.loading) {
        vm.refreshing = false
        return
      }
      vm.loading = true
      axios.post('/api/interaction_notification/list', {
        curPage: vm.curPage,
        pageSize: vm.pageSize
      }).then(response => {
        vm.loading = false
        vm.refreshing = false
        var body = response.data
        if (body.code !== 0) {
          Toast.fail(vm.$t('toast_load_notifications_failed', { msg: body.msg }))
          vm.finished = true
          return
        }
        var data = body.data
        if (data.interactionNotifications && data.interactionNotifications.length > 0) {
          vm.notifications = vm.notifications.concat(data.interactionNotifications)
          if (data.interactionNotifications.length < vm.pageSize) {
            vm.finished = true
          }
          vm.curPage = parseInt(data.curPage || vm.curPage) + 1
        } else {
          vm.finished = true
        }
      }).catch(error => {
        console.log(error)
        vm.loading = false
        vm.refreshing = false
        vm.finished = true
        Toast.fail(vm.$t('toast_load_notifications_error'))
      })
    },
    getNotificationDesc(notification) {
      if (notification.type === 'comment') {
        const content = notification.content || ''
        return this.$t('interaction_notification_comment', { content: content ? ': ' + content : '' })
      } else if (notification.type === 'reply') {
        const content = notification.content || ''
        return this.$t('interaction_notification_reply', { content: content ? ': ' + content : '' })
      } else if (notification.type === 'like') {
        const content = notification.content || ''
        return this.$t('interaction_notification_like') + (content ? ': ' + content : '')
      } else if (notification.type === 'bookmark') {
        const content = notification.content || ''
        return this.$t('interaction_notification_bookmark') + (content ? ': ' + content : '')
      }
      return ''
    },
    async onNotificationClick(notification) {
      // 标记已读
      if (notification.isRead == 0) {
        try {
          await axios.post('/api/interaction_notification/mark_read', {
            interactionNotificationId: String(notification.interactionNotificationId)
          })
          notification.isRead = 1
          // 检查是否还有未读
          const hasUnread = this.notifications.some(n => n.isRead == 0)
          this.$store.commit('setHasUnreadInteraction', hasUnread)
        } catch (e) {
          console.error('mark read error:', e)
        }
      }
      // 跳转到对应的 channel/session
      if (notification.channelId && notification.channelId !== '0') {
        this.$router.push({
          path: '/channel/' + String(notification.channelId),
          query: {
            chatSessionId: notification.chatSessionId ? String(notification.chatSessionId) : undefined
          }
        })
      }
      this.$emit('close')
    },
    async markAllRead() {
      try {
        await axios.post('/api/interaction_notification/mark_all_read', {})
        this.notifications.forEach(n => { n.isRead = 1 })
        this.$store.commit('setHasUnreadInteraction', false)
        Toast.success(this.$t('operationSuccess'))
      } catch (e) {
        console.error('mark all read error:', e)
        Toast.fail(this.$t('operationFailed'))
      }
    },

  }
}
</script>

<style scoped>
.interaction-notification-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F7F5F2;
}

.in-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #E0DDD8;
  flex-shrink: 0;
}

.in-header-left,
.in-header-right {
  width: 60px;
  display: flex;
  align-items: center;
}

.in-header-right {
  justify-content: flex-end;
}

.in-header-title {
  font-size: 16px;
  font-weight: 600;
  color: #1A1A1A;
  text-align: center;
  flex: 1;
}

.in-list-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.in-item {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  margin-bottom: 4px;
  background: white;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.in-item:active {
  background-color: #FAFAF8;
}

.in-avatar {
  margin-right: 12px;
  flex-shrink: 0;
}

.in-avatar-placeholder {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #E8543A;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}

.in-content {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.in-name-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.in-username {
  font-size: 14px;
  font-weight: 600;
  color: #1A1A1A;
}

.in-time {
  font-size: 11px;
  color: #8A8A8A;
}

.in-desc {
  font-size: 13px;
  color: #4A4A4A;
}

.in-desc.in-unread {
  font-weight: 600;
  color: #1A1A1A;
}

.in-preview {
  font-size: 12px;
  color: #8A8A8A;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.in-right {
  display: flex;
  align-items: center;
  margin-left: 8px;
  flex-shrink: 0;
}

.in-unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #E05252;
}
</style>



// WEBPACK FOOTER //
// src/components/InteractionNotification.vue